module.exports = __webpack_public_path__ + "img/logo_antiquity.4c8b8ea3.png";